import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { EDIT_QUESTION } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { EditQuestion, EditQuestionDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadEditQuestion =
  (
    idSurvey: number,
    idQuestion: number,
    questions: EditQuestion,
  ): ThunkAction<Promise<void>, State, null, EditQuestionDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: EDIT_QUESTION + REQUEST });
    try {
      const payload = await api.loadEditQuestion(
        idSurvey,
        idQuestion,
        questions,
      );
      dispatch({ type: EDIT_QUESTION + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: EDIT_QUESTION + FAILURE, error });
    }
  };

export const editQuestionIdle = () => ({ type: EDIT_QUESTION + IDLE });
